import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Tabs, Tab, Table, Pagination } from 'react-bootstrap';
import './ActivityLogModal.scss'; // Assuming you have a CSS file for styles
import _ from 'lodash';
import { goToLPDetailUtil, redirectToPageUtil, SessionKeys } from '../../../utils/AppUtils';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
const ActivityLogModal = (props) => {
  const { show, setShow, ringData } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [learn, setLearn] = useState(ringData.learn);
  const [plan, setPlan] = useState(ringData.plan);
  const [act, setAct] = useState(ringData.act);
  const [learnGlobal, setLearnGlobal] = useState(ringData.learn);
  const [planGlobal, setPlanGlobal] = useState(ringData.plan);
  const [actGlobal, setActGlobal] = useState(ringData.act);
  const authBroker = useSelector((state) => state.auth.authBroker);
    const [courseData, setCourseData] = useState({});

  const pageSize = 5;
  const [key, setKey] = useState('learn');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(Math.ceil(learn.length / pageSize));

  useEffect(() => {
    let dataLength = 0;
    if (key === 'learn') dataLength = learnGlobal.length;
    else if (key === 'plan') dataLength = planGlobal.length;
    else if (key === 'act') dataLength = actGlobal.length;
    setTotalPages(Math.ceil(dataLength / pageSize));
    setPage(1);
  }, [key])

  useEffect(() => {
    if (key === 'learn') {
      setLearn(ringData?.learn?.slice((page - 1) * pageSize, page * pageSize));
    } else if (key === 'plan') {
      setPlan(ringData?.plan?.slice((page - 1) * pageSize, page * pageSize));
    } else if (key === 'act') {
      setAct(ringData?.act?.slice((page - 1) * pageSize, page * pageSize));
    }
  }, [page,key])

  const redirection=(item)=>{
    if(item?.is_session===true || item?.entity_status ==="0"){
      return;
    }
if(item?.product_type==="course"){
                          redirectToPageUtil(
                  item,
                  navigate,
                  authBroker,
                  setCourseData,
                  dispatch,
                  "course"
                )
                      }else{
goToLPDetailUtil(item, navigate, 1)
                      }
  }

  return (
    <>
      <Modal className="activitylog" show={show} onHide={() => { setShow(false) }} scrollable centered>
        <Modal.Header closeButton className='border-bottom-0'>
          <Modal.Title>Monthly activity details</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pt-0'>
          {<div className="custom-tabs-container">
            <Tabs
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="custom-tabs"
            >
              <Tab eventKey="learn" title="Learn">
                {!_.isEmpty(learn)?<div className="subtext mt-2">
                  Complete 5 items: View article, play audio clip, complete a course, play a video, play a webinar recording.
                </div>:""}
                <div className="content-table">
                  {!_.isEmpty(learn)?<div className="table-header">
                    <span>Content</span>
                    <span className="text-end">Date</span>
                  </div>:""}
                  {learn.map((item, idx) => (
                    <div className="table-row" key={idx}>
                      {item?.is_session || item?.entity_status ==="0" ?<p>{item.name}</p>:<a onClick={()=>{
                        redirection(item);
                      }} className="content-link cursor-pointer" title={item.name}>{item.name}</a>}
                      <span className="date">{item.complete_date}</span>
                    </div>
                  ))}
                  {_.isEmpty(learn)?<div className="learn-empty-state">
                    <div className="learn-content">
                      <img src="/images/finwell-img/Discover.svg" alt="Binoculars" className="learn-image" />
                      <div className="learn-text">
                        <p className="learn-message">
                          You haven’t completed any Learn activities this month yet! Explore content like:
                        </p>
                        <ul className="learn-list">
                          <li>View article</li>
                          <li>Play audio clip</li>
                          <li>Complete a course</li>
                          <li>Play a video</li>
                          <li>Play a webinar recording</li>
                        </ul>
                      </div>
                    </div>
                  </div>:""}
                </div>
              </Tab>
              <Tab eventKey="plan" title="Plan">
                {!_.isEmpty(plan)?<div className="subtext mt-2">
                  Complete 3 items: Schedule a coaching session, complete an assessment, use Money Metrics.
                </div>:""}
                <div className="content-table">
                  {!_.isEmpty(plan)?<div className="table-header">
                    <span>Content</span>
                    <span className="text-end">Date</span>
                  </div>:""}
                  {plan.map((item, idx) => (
                    <div className="table-row" key={idx}>
                      {item?.is_session || item?.entity_status ==="0"?<p>{item.name}</p>:<a onClick={()=>{
                        redirection(item);
                      }} className="content-link cursor-pointer" title={item.name}>{item.name}</a>}
                      <span className="date">{item.complete_date}</span>
                    </div>
                  ))}
                  {_.isEmpty(plan)?<div className="learn-empty-state">
                    <div className="learn-content">
                      <img src="/images/finwell-img/Discover.svg" alt="Binoculars" className="learn-image" />
                      <div className="learn-text">
                        <p className="learn-message">
                          You haven’t completed any Plan activities this month yet! Explore content like:
                        </p>
                        <ul className="learn-list">
                          <li>Schedule a coaching session</li>
                          <li>Complete an assessment</li>
                          <li>Use Money Metrics</li>
                          {/* <li>Accessing a document</li> */}
                        </ul>
                      </div>
                    </div>
                  </div>:""}
                </div>
              </Tab>
              <Tab eventKey="act" title="Act">
                {!_.isEmpty(act)?<div className="subtext mt-2">
                  Complete 3 items: Attend coaching session, access a calculator, complete an Action Path.
                </div>:""}
                <div className="content-table">
                  {!_.isEmpty(act)?<div className="table-header">
                    <span>Content</span>
                    <span className="text-end">Date</span>
                  </div>:""}
                  {act.map((item, idx) => (
                    <div className="table-row" key={idx}>
                      {item?.is_session || item?.entity_status ==="0"?<p>{item.name}</p>:<a onClick={()=>{
                        redirection(item);
                      }} className="content-link cursor-pointer" title={item.name}>{item.name}</a>}
                      <span className="date">{item.complete_date}</span>
                    </div>
                  ))}
                  {_.isEmpty(act)?<div className="learn-empty-state">
                    <div className="learn-content">
                      <img src="/images/finwell-img/Discover.svg" alt="Binoculars" className="learn-image" />
                      <div className="learn-text">
                      <p className="learn-message">
                          You haven't completed any Act activities this month yet! Explore content like:
                        </p>
                        <ul className="learn-list">
                          <li>Attend coaching session</li>
                          <li>Access a calculator</li>
                          {/* <li>Accessing a document</li> */}
                          <li>Complete an Action Path</li>
                        </ul>
                      </div>
                    </div>
                  </div>:""}
                </div>
              </Tab>
            </Tabs>
            {totalPages > 1 && <div className="pagination">
              <button onClick={() => setPage(Math.max(page - 1, 1))}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12.2079 0.144C12.1119 0.048 11.9946 0 11.856 0C11.7173 0 11.5999 0.048 11.5039 0.144L3.64795 8L11.5039 15.856C11.5999 15.952 11.7173 16 11.856 16C11.9946 16 12.1119 15.952 12.2079 15.856C12.3039 15.76 12.3519 15.6427 12.3519 15.504C12.3519 15.3653 12.3039 15.248 12.2079 15.152L5.05595 8L12.2079 0.848C12.3039 0.752 12.3519 0.634666 12.3519 0.495999C12.3519 0.357333 12.3039 0.24 12.2079 0.144Z" fill="#474747" />
              </svg></button>
              <span className="page-box">{page}</span>
              <span className="of-text">of {totalPages}</span>
              <button onClick={() => setPage(Math.min(page + 1, totalPages))}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.79195 0.144C3.88795 0.048 4.00528 0 4.14395 0C4.28262 0 4.39995 0.048 4.49595 0.144L12.3519 8L4.49595 15.856C4.39995 15.952 4.28262 16 4.14395 16C4.00528 16 3.88795 15.952 3.79195 15.856C3.69595 15.76 3.64795 15.6427 3.64795 15.504C3.64795 15.3653 3.69595 15.248 3.79195 15.152L10.9439 8L3.79195 0.848C3.69595 0.752 3.64795 0.634666 3.64795 0.495999C3.64795 0.357333 3.69595 0.24 3.79195 0.144Z" fill="#474747" />
              </svg></button>
            </div>}
          </div>}


        </Modal.Body>
        <Modal.Footer className='border-top-0 d-flex justify-content-end pt-0'>
          <button className="session-btn" onClick={()=>{navigate(
                          `/profile/edit?section=edit&tab=2&user_id=${authBroker?.payload?.user.user_id
                          }`
                        );}}>View all activity</button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActivityLogModal;
